import { render, staticRenderFns } from "./ErrorRoleModal.vue?vue&type=template&id=24d6bd38&scoped=true&"
import script from "./ErrorRoleModal.vue?vue&type=script&lang=js&"
export * from "./ErrorRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./ErrorRoleModal.vue?vue&type=style&index=0&id=24d6bd38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d6bd38",
  null
  
)

export default component.exports